enum AccountSignInConstants {
  CreateAccountSignInRequest = 'CREATE_ACCOUNT_SIGN_IN_REQUEST',
  CreateAccountSignInSuccess = 'CREATE_ACCOUNT_SIGN_IN_SUCCESS',
  CreateAccountSignInFailure = 'CREATE_ACCOUNT_SIGN_IN_FAILURE'
}

export default AccountSignInConstants
